import React, { useEffect, useState } from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { loadGooglePlacesScript } from "../utils/helpers/googlePlacesLoader";

const GOOGLE_PLACES_ROUTES = [
  "/hin/employer/edit-profile",
  "/hin/client/edit-profile",
  "/hin/client/post-event",
  "/hin/client/edit-event/",
  "/hin/cook/edit-catering-profile",
  "/hin/cook/editcateringprofile",
];

const useAuth = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.data?.mobileVerified) {
    return true;
  } else {
    return false;
  }
};

const ProtectedRoutes = (props) => {
  const auth = useAuth();
  const location = useLocation();
  const user1 = JSON.parse(localStorage.getItem("user"));

  const pathname = location.pathname; // Extract pathname from URL
  const needsGooglePlaces =
    auth && GOOGLE_PLACES_ROUTES.some((route) => pathname.startsWith(route));
  const [googlePlacesStatus, setGooglePlacesStatus] = useState("idle");

  useEffect(() => {
    if (!needsGooglePlaces) {
      setGooglePlacesStatus("idle");
      return;
    }

    let cancelled = false;
    setGooglePlacesStatus("loading");
    loadGooglePlacesScript()
      .then(() => {
        if (!cancelled) setGooglePlacesStatus("ready");
      })
      .catch(() => {
        if (!cancelled) setGooglePlacesStatus("error");
      });

    return () => {
      cancelled = true;
    };
  }, [needsGooglePlaces]);

  const role = localStorage.getItem("role");
  localStorage.setItem("applicationUrl", pathname);

  const isPublicEmployerSignup =
    pathname === "/employer/signup" || pathname === "/hin/employer/signup";
  if (isPublicEmployerSignup) {
    const target =
      pathname === "/hin/employer/signup"
        ? `/hin/employer-registration${location.search || ""}`
        : `/employer-registration${location.search || ""}`;
    return <Navigate to={target} replace />;
  }

  if (auth && location.pathname === "/login") {
    if (user1?.data?.role === "cook") {
      return <Navigate to="/cook/dashboard" />;
    } else if (user1?.data?.role === "client") {
      return <Navigate to="/client/dashboard" />;
    } else {
      return <Navigate to="/employer/dashboard" />;
    }
  }
  if (
    !auth &&
    pathname &&
    (pathname?.includes("/employer") || pathname?.includes("/client"))
  ) {
    return <Navigate to="/employer-login" />;
  } else if (!auth && pathname && pathname?.includes("/cook")) {
    return <Navigate to="/login" />;
  } else if (!auth && role === "employer") {
    return <Navigate to="/employer-login" />;
  } else if (!auth && role === "cook") {
    return <Navigate to="/login" />;
  }

  if (needsGooglePlaces && googlePlacesStatus === "loading") {
    return <div role="status" className="route-loading">Loading location tools…</div>;
  }

  if (needsGooglePlaces && googlePlacesStatus === "error") {
    return <div role="alert" className="route-loading">Unable to load location tools.</div>;
  }

  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
